import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import DesktopContainer from 'layouts/DesktopContainer'
import GoogleMap from 'common/GoogleMap'
import Loader from 'components/Loader'
import { mobileFirstMedia as media } from 'utils/media'

import { VenueBusinessHour, VenueAddress, VenuePhone } from 'common/VenueInfo'

const VendorFooter = ({
  address,
  openingHours,
  phone,
  location = {},
  name,
}) => {
  return (
    <DesktopContainer background="gray7">
      <section className="xl:flex">
        <div className="xl:w-1/4 px-15 pt-50 xl:pr-15 xl:pl-0 xl:py-50">
          <VenueBusinessHour openingHours={openingHours} />
        </div>
        <div className="xl:w-1/4 px-15 pt-30 pb-50 xl:pr-30 xl:pl-0 xl:py-50">
          <VenueAddress address={address} />
          <VenuePhone phone={phone} className="xl:pt-20 pt-30" />
        </div>
        <div className="xl:w-1/2 xl:py-40">
          <GoogleMap
            containerElement={<MapContainer />}
            address={address}
            name={name}
            center={location.geo}
            loadingElement={<Loader minHeight={100} />}
          />
        </div>
      </section>
    </DesktopContainer>
  )
}

VendorFooter.propTypes = {
  name: PropTypes.string,
  location: PropTypes.object,
  phone: PropTypes.string,
  address: PropTypes.object,
  openingHours: PropTypes.array,
}

const MapContainer = styled.div`
  height: 180px;

  ${media.screen`
    height: 220px;
  `}
`

export default VendorFooter
